import AddressIcon from "src/assets/all-icons/address-icon.jsx";

import './styles/OrderShippingCard.css';

export default function OrderShippingCard({ shippingData, onAddAddress }) {
  const hasAddress = Boolean(
    shippingData &&
    shippingData.address_name &&
    shippingData.address_street &&
    shippingData.address_country
  );
  const phonePrefix = shippingData?.address_phone?.address_phone_prefix ?? "";
  const phoneNumber = shippingData?.address_phone?.address_phone_number ?? "";
  const canAddAddress = typeof onAddAddress === "function";

  if (!hasAddress) {
    return (
      <div className="order-shipping-card__container order-shipping-card__container--empty">
        <AddressIcon className="order-shipping-card__icon"/>
        <div className="order-shipping-card__info">
          <span className="order-shipping-card__main-text order-shipping-card__main-text--emphasis">
            Finish purchase
          </span>
          <span className="order-shipping-card__text">
            Contact seller for handling and delivery details.
          </span>
          {canAddAddress && (
            <button
              type="button"
              className="order-shipping-card__cta-button"
              onClick={onAddAddress}
            >
              Add shipping details
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="order-shipping-card__container">
      <AddressIcon className="order-shipping-card__icon"/>

      <div className="order-shipping-card__info">
        <span className="order-shipping-card__main-text order-shipping-card__main-text--emphasis">
          {shippingData.address_name} {shippingData.address_surname}
        </span>

        {(phonePrefix || phoneNumber) && (
          <span className="order-shipping-card__main-text">
            {phonePrefix} {phoneNumber}
          </span>
        )}

        <span className="order-shipping-card__text">
          {shippingData.address_street}
        </span>

        <span className="order-shipping-card__text">
          {shippingData.address_city}{", "}
          {shippingData.address_region}{", "}
          {shippingData.address_country}{", "}
          {shippingData.address_zip_code}
        </span>
      </div>
    </div>
  );
}
